export function getRetailPrice(htmlRootElement: HTMLElement): number | null {
    const price = htmlRootElement?.getAttribute('data-retail-price') || '';
    return !price ? null : +price;
}
